import { useMemo } from 'react';

import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Badge, { BadgeProps } from '@mui/material/Badge';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import { colors } from 'src/utils/customColors';

import { AdvancedFiltersState } from '../AdvancedFilters';

const badgeAnchorOrigin: BadgeProps['anchorOrigin'] = {
  vertical: 'top',
  horizontal: 'right',
};

interface Props {
  open: boolean;
  handleOpenFilters: () => void;
  filters: AdvancedFiltersState[];
}

const badgeStyleSx = {
  alignSelf: 'flex-start',
  position: 'absolute',
  right: 0,
};

export default function AdvancedFiltersButton({
  open,
  handleOpenFilters,
  filters,
}: Props) {
  const badgeCount = useMemo(() => {
    return filters.filter((filter) => filter.name).length;
  }, [filters]);

  return (
    <Button
      variant="outlined"
      size="small"
      sx={(theme) => ({
        backgroundColor: open ? colors.lightestBlue : 'transparent',
        borderColor: open ? colors.lightestBlue : colors.darkerBlue,
        padding: theme.spacing(0.5),
      })}
      onClick={handleOpenFilters}
    >
      <Grid size={12} container alignItems="center" spacing={0.5}>
        <FilterListOutlinedIcon fontSize="small" />
        {open ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
      </Grid>
      <Badge
        badgeContent={badgeCount}
        anchorOrigin={badgeAnchorOrigin}
        color="primary"
        sx={badgeStyleSx}
      />
    </Button>
  );
}
